import { Brand, BrandGroup, Env } from '../../api'
import { getAuth0Feature } from '../../core/pure/Window'

export const getBrand = (): Brand => MH_BRAND || 'nb'
export const getBrandGroup = (): BrandGroup => MH_BRAND_GROUP || 'mhbe'
export const getEnv = (): Env => MH_ENV
export const getPurposeId = (): string | null => {
  // Temporary override for DL for Forgerock legacy purposes
  // Can be removed after Auth0 release
  if (!getAuth0Feature() && MH_BRAND === 'dl') {
    return '3392ebb4-aed8-4c33-ac7a-c22fa2a07848'
  }

  return PURPOSE_ID
}
